import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subject, combineLatest, takeUntil } from "rxjs";
import { Store } from '@ngrx/store';
import { selectCashieringIraAgreementText} from "../../../create-request/reducers";
import { selectStandingAuthCashieringIraAgreement } from "../../../standing-authorizations/reducers";

@Component({
  standalone: false,
    selector: 'cashiering-ira-agreement-modal',
    templateUrl: './cashiering-ira-agreement-modal.component.html',
    styleUrls: ['./cashiering-ira-agreement-modal.component.scss'],
})
export class CashieringIraAgreementModalComponent implements OnInit, OnDestroy {
    @Input() showModal: Observable<boolean>;
    modal: EverestModal;
    modalBodyText: string;
    destroy$: Subject<boolean> = new Subject<boolean>();
    cashieringIraAgreementText: string = '';

    constructor(private store: Store) {}

    ngOnInit(): void {

        combineLatest([
          this.store.select(selectCashieringIraAgreementText),
          this.store.select(selectStandingAuthCashieringIraAgreement)
        ]).pipe(takeUntil(this.destroy$))
        .subscribe(([inputText, checkStandingAuthText]) => {
          if(inputText){
            this.modalBodyText = inputText;
          }
          if(checkStandingAuthText){
            this.modalBodyText =checkStandingAuthText;
          }
        });

        this.modal = document.getElementById('cashiering-ira-agreement-modal') as EverestModal;
        this.showModal?.pipe(takeUntil(this.destroy$)).subscribe((show) => {
            if (show) this.modal.showModal();
            document.documentElement.style.overflow = 'hidden'; //hide second vertical scroll bar
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }

    onPrintClick(): void {
        //Match styling on the printable document to the modal
        let customStyle =
        `p, li {
            font-family: Arial;
            font-size: 16px;
            line-height: 19px;
            letter-spacing: normal;
        }
        b {
            font-family: CharlesModern-Regular;
            font-size: 19px;
        }
        h1 {
            font-family: CharlesModern-Regular;
            font-size: 19px;
            line-height: 28px;
        }`;

        //Opening a new popup window to print from, until we can figure out how to properly print the modal content
        const printWindow = window.open(' ', '', 'height=900,width=900');
        if (printWindow !== null) {
            printWindow.document.write('<html><head><style>' + customStyle + '</style>');
            printWindow.document.write('<title>Cashiering IRA Agreement</title></head>'); //document title
            printWindow.document.write('<h1>Cashiering IRA Agreement</h1>');
            printWindow.document.write(this.modalBodyText);

            printWindow.window.print();
            printWindow.window.close();
        }
    }

    onCloseClick(): void {
        this.modal.hideModal();
        document.documentElement.style.overflow = 'hidden'; //re-display vertical scroll bar after dismissing modal
    }
}

type EverestModal = HTMLElement & {
    showModal: () => {},
    hideModal: () => {}
};
